import React from 'react';
import { Accordion } from '@noths/polaris-client-ribbons-design-system';

import type { PublicAttribute } from 'src/redux/product/types';
import * as styles from './PublicAttributes.styles';

interface PublicAttributesProps {
  publicAttributes: PublicAttribute[];
}

const formatAttributeValues = (values: (string | number | boolean | null)[]): string => {
  return values
    .filter((value) => value !== null && value !== undefined)
    .map((value) => String(value))
    .join(', ');
};

export const PublicAttributes = ({ publicAttributes }: PublicAttributesProps) => {
  if (publicAttributes.length === 0) {
    return null;
  }

  return (
    <Accordion id="publicAttributes" open={false} title={<h3>Product attributes</h3>}>
      <div css={styles.container}>
        {publicAttributes.map((attribute) => {
          const formattedValues = formatAttributeValues(attribute.values);

          if (!formattedValues) {
            return null;
          }

          return (
            <div css={styles.attributeItem} key={attribute.key}>
              <b>{attribute.title}:</b> {formattedValues}
            </div>
          );
        })}
      </div>
    </Accordion>
  );
};
